// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inline-dropdown-container {
  display: flex;
  align-items: center;
  color: var(--gray);
  font-size: 0.875rem;
}
.inline-dropdown-container .label-container {
  margin-right: 8px;
}

.tooltip-helper {
  margin-left: 8px;
  cursor: help;
}
.tooltip-helper span {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-color: var(--gray_light2);
  border-radius: 50%;
  font-size: 0.75em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--base_color2);
}
.tooltip-helper [id^=tooltip-chart-help-tt] {
  max-width: 420px;
}
.tooltip-helper.selector .selected-value {
  display: flex;
  justify-content: space-between;
  border: 1px solid var(--gray);
  padding: 6px;
  border-radius: 4px;
  font-size: 13px;
}
.tooltip-helper.selector .selected-value.opened {
  border-color: var(--color_primary_500);
}
.tooltip-helper.selector .simple-card-container {
  overflow: hidden;
}
.tooltip-helper.selector .option.active {
  background: var(--color_primary_500);
  color: var(--base_color2);
  font-weight: bolder;
}
.tooltip-helper.selector .option:hover:not(.active) {
  background: var(--primary_light2);
}`, "",{"version":3,"sources":["webpack://./src/components/InlineDropdown/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,gBAAA;EACA,YAAA;AAAF;AAEE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAKI;EACE,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAHN;AAKM;EACE,sCAAA;AAHR;AAOI;EACE,gBAAA;AALN;AASM;EACE,oCAAA;EACA,yBAAA;EACA,mBAAA;AAPR;AAUM;EACE,iCAAA;AARR","sourcesContent":[".inline-dropdown-container {\n  display: flex;\n  align-items: center;\n  color: var(--gray);\n  font-size: 0.875rem;\n\n  .label-container {\n    margin-right: 8px;\n  }\n}\n\n.tooltip-helper {\n  margin-left: 8px;\n  cursor: help;\n\n  span {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    background-color: var(--gray_light2);\n    border-radius: 50%;\n    font-size: 0.75em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: var(--base_color2);\n  }\n\n  [id^='tooltip-chart-help-tt'] {\n    max-width: 420px;\n  }\n\n  &.selector {\n    .selected-value {\n      display: flex;\n      justify-content: space-between;\n      border: 1px solid var(--gray);\n      padding: 6px;\n      border-radius: 4px;\n      font-size: 13px;\n\n      &.opened {\n        border-color: var(--color_primary_500);\n      }\n    }\n\n    .simple-card-container {\n      overflow: hidden;\n    }\n\n    .option {\n      &.active {\n        background: var(--color_primary_500);\n        color: var(--base_color2);\n        font-weight: bolder;\n      }\n\n      &:hover:not(.active) {\n        background: var(--primary_light2);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
